/// <reference types="vite/client" />
import Encryption from 'utils/aes';
import * as _ from 'lodash';

const isDev: Boolean = import.meta.env.DEV;

// 路由模式
const routerMode: String = 'history';

// https://sky503v2-h5.xbnapi.xyz
function baseUrl() {
    return isDev ? `/api` : `/api`;
}

function baseUrlLottery() {
    return isDev ? `/api_v2` : `/api_v2`;
}

export type GameType = 'diceGame' | 'doubleGame' | 'coinFlipGame' | 'crashGame' | 'ringGame' | 'rouletteGame' | 'crashGame60' | 'crashGame180' | 'crashGame300';

function socketUrl(uid: number, gameType: GameType) {
    const time = Math.floor(Date.now() / 1000);
    const timestamp = btoa(Encryption.encrypt(`${time}`));
    return isDev ? `https://sky503v2-h5.xbnapi.xyz/ws?uid=${uid}&name=${gameType}&token=${timestamp}` : `wss://${window.location.hostname}/ws?uid=${uid}&name=${gameType}&token=${timestamp}`;
}

function socketUrlNotUid(gameType: GameType) {
    const time = Math.floor(Date.now() / 1000);
    const timestamp = btoa(Encryption.encrypt(`${time}`));
    return isDev ? `https://sky503v2-h5.xbnapi.xyz/ws?name=${gameType}&token=${timestamp}` : `wss://${window.location.hostname}/ws?name=${gameType}&token=${timestamp}`;
}

// 国内彩票socket
function socketUrlLottery(uid?: string, username?: string, channel?: string, gameCode?: string) {
    // console.log(uid, username, channel, gameCode, _.isEmpty(uid) || _.isEmpty(username), '---------------1');
    if (_.isEmpty(uid) || _.isEmpty(username)) {
        if (gameCode === '0') {
            return isDev ? `wss://sky503v2-h5.xbnapi.xyz/ws-lottery?channel=${channel}` : `wss://${window.location.hostname}/ws-lottery?channel=${channel}`;
        }
        return isDev ? `wss://sky503v2-h5.xbnapi.xyz/ws-lottery?channel=${channel}&gameCode=${gameCode}` : `wss://${window.location.hostname}/ws-lottery?channel=${channel}&gameCode=${gameCode}`;
    }
    return isDev
        ? `wss://sky503v2-h5.xbnapi.xyz/ws-lottery?uid=${uid}&username=${username}&channel=${channel}&gameCode=${gameCode}`
        : `wss://${window.location.hostname}/ws-lottery?uid=${uid}&username=${username}&channel=${channel}&gameCode=${gameCode}`;
}

// 体育socket
function socketUrlSport(uid?: string, username?: string, channel?: string, gameCode?: string) {
    if (_.isEmpty(uid) || _.isEmpty(username)) {
        if (gameCode === '0') {
            return isDev ? `wss://sky503v2-h5.xbnapi.xyz/ws-sport?channel=${channel}` : `wss://${window.location.hostname}/ws-sport?channel=${channel}`;
        }
        return isDev ? `wss://sky503v2-h5.xbnapi.xyz/ws-sport?channel=${channel}&gameCode=${gameCode}` : `wss://${window.location.hostname}/ws-sport?channel=${channel}&gameCode=${gameCode}`;
    }
    return isDev
        ? `wss://sky503v2-h5.xbnapi.xyz/ws-sport?uid=${uid}&username=${username}&channel=${channel}&gameCode=${gameCode}`
        : `wss://${window.location.hostname}/ws-sport?uid=${uid}&username=${username}&channel=${channel}&gameCode=${gameCode}`;
}

export { baseUrl, baseUrlLottery, isDev, socketUrl, socketUrlNotUid, socketUrlLottery, socketUrlSport, routerMode };
